// Chat empty state
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisEmptyState = `
/* Empty state */
.pr-empty {
  flex: 1;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 48px 28px;
  text-align: center;
  max-width: 720px; margin: 0 auto; width: 100%;
}
.pr-empty-hero {
  width: 48px; height: 48px;
  border-radius: var(--pr-r-md);
  background: var(--pr-ink);
  display: grid; place-items: center; color: var(--pr-surface);
  margin-bottom: 20px;
  font-family: var(--pr-font-serif); font-style: italic;
  font-weight: 500; font-size: 22px;
  box-shadow: var(--pr-shadow-md);
}
.pr-empty-hero img { width: 100%; height: 100%; border-radius: var(--pr-r-md); object-fit: cover; }
.pr-empty .pr-greeting {
  font-size: 12px; color: var(--pr-ink-4);
  margin-bottom: 10px;
  font-weight: 400;
}
.pr-empty h1 {
  font-family: var(--pr-font-serif);
  margin: 0; font-size: 30px; font-weight: 500; letter-spacing: -0.02em; color: var(--pr-ink);
  line-height: 1.2;
  max-width: 520px;
}
.pr-empty p {
  margin: 12px 0 0; font-size: 14px; color: var(--pr-ink-3);
  max-width: 440px; line-height: 1.6;
}
.pr-suggestions {
  display: grid; grid-template-columns: 1fr 1fr; gap: 10px;
  margin-top: 30px; max-width: 620px; width: 100%;
}
.pr-suggestion {
  display: flex; align-items: flex-start; gap: 12px;
  padding: 14px 16px;
  background: var(--pr-surface);
  border: 1px solid var(--pr-border);
  border-radius: var(--pr-r-md);
  cursor: pointer;
  text-align: left;
  transition: all 150ms ease;
  color: var(--pr-ink);
  font-size: 13px;
  font-family: inherit;
}
.pr-suggestion:hover {
  border-color: var(--pr-ink-4);
  box-shadow: var(--pr-shadow-sm);
  transform: translateY(-1px);
}
.pr-suggestion-icon {
  width: 28px; height: 28px;
  border-radius: var(--pr-r-sm);
  background: var(--pr-accent-soft);
  color: var(--pr-accent);
  display: grid; place-items: center;
  flex-shrink: 0;
}
.pr-suggestion-body { min-width: 0; flex: 1; }
.pr-suggestion-body strong { font-weight: 600; font-size: 13px; color: var(--pr-ink); display: block; }
.pr-suggestion-body .pr-sub { display: block; font-size: 12px; color: var(--pr-ink-4); margin-top: 3px; line-height: 1.5; }
`;
